import { mutationOptions } from '@tanstack/react-query';

import apiClient from '@/constants/http';
import { Logger } from '@/utils/logging';

import type {
  SubmitNPSResponseMutationOptions,
  SubmitNPSResponsePayload,
  SubmitNPSResponseResponse,
} from './types';

/**
 * Submit an NPS survey response.
 *
 * @param payload - The campaign ID, score, and optional feedback
 * @returns The API response indicating success
 */
const submitNPSResponse = async (
  payload: SubmitNPSResponsePayload,
): Promise<SubmitNPSResponseResponse> => {
  try {
    const { data } = await apiClient.post<SubmitNPSResponseResponse>(
      '/v1/surveys/response',
      payload,
    );
    return data;
  } catch (error) {
    Logger.error('Error submitting NPS response', { error });
    throw error;
  }
};

export const submitNPSResponseMutation = (
  options?: SubmitNPSResponseMutationOptions,
) =>
  mutationOptions({
    mutationFn: (payload: SubmitNPSResponsePayload) =>
      submitNPSResponse(payload),
    mutationKey: ['submitNPSResponse'],
    retry: false,
    ...options,
  });
